export const checkIfStringIsDate = (value) => {
    if (value === null || value === undefined) {
        return true;
    }
    const parsedDate = new Date(value);
    return !Number.isNaN(parsedDate.getTime())
        && value === parsedDate.toISOString();
};
